import React from 'react';
import createReactClass from 'create-react-class';

class SayHello extends React.Component {
  constructor(props) {
    super(props);
    this.state = {message: 'Hello!'};
    // This line is important!
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    alert(this.state.message);
  }

  render() {
    // Because `this.handleClick` is bound, we can use it as an event handler.
    return (
      <button onClick={this.handleClick}>
        Say hello
      </button>
    );
  }
}

var SayHelloF = createReactClass({
  getInitialState: function() {
    return {message: 'Hello!'};
  },

  handleClick: function() {
    alert(this.state.message);
  },

  render: function() {
    return (
      <button onClick={this.handleClick}>
        Say hello
      </button>
    );
  }
});

class SayHelloCE extends React.Component {
  constructor(props) {
    super(props);
    this.state = {message: 'Hello!'};
  }
  // WARNING: this syntax is experimental!
  // Using an arrow here binds the method:
  handleClick = () => {
    alert(this.state.message);
  }

  render() {
    return (
      <button onClick={this.handleClick}>
        Say hello
      </button>
    );
  }
}

const ReactWithoutES6 = () => (
	<section>
		With ES6<br />
		<SayHello />
		<hr />
		Without ES6<br />
		<SayHelloF />
		<hr />
		Babel experimental<br />
		<SayHelloCE />
	</section>
	)

export default ReactWithoutES6;


// WEBPACK FOOTER //
// ./src/pages/advance/react-without-es6/index.jsx